import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class PacienteService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'pacientes';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'pacientes';
  }

  procurarPacientePorCpf(cpfPaciente: string): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/cpf/${cpfPaciente}`);
  }

  criar(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPublic()}`, entity);
  }

  atualizar(entity: Object): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPublic()}`, entity);
  }

  listarComProjecao(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comProjecao`);
  }

  procurarPacientePorFiltro(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro`, filtro);
  }

  procurarPacientePorFiltroComProjecao(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro/comProjecao`, filtro);
  }

  procurarPacienteEDependentePorFiltroComProjecao(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro/pacienteEDependente/comProjecao`, filtro);
  }

}
